/* global axios */
import ApiClient from './ApiClient';

class Financial extends ApiClient {
  constructor() {
    super('financial', { accountScoped: true });
  }

  cancel(reason, { cancelAccount = false } = {}) {
    return axios.delete(this.url, {
      data: { reason, cancel_account: cancelAccount },
    });
  }

  pix(paymentId) {
    return axios.get(
      `${this.url}/payments/${encodeURIComponent(paymentId)}/pix`
    );
  }

  payWithCreditCard(paymentId, creditCard) {
    return axios.post(
      `${this.url}/payments/${encodeURIComponent(paymentId)}/credit_card`,
      { credit_card: creditCard }
    );
  }
}

export default new Financial();
